var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DOMcreateElement } from '../typescript/TSXDomParse';
export default function FooterImageLink(_a) {
    var url = _a.url, title = _a.title;
    if (!(url === null || url === void 0 ? void 0 : url.length))
        return '';
    return (DOMcreateElement("img", __assign({ className: "footer-image-link" }, (title ? { alt: title } : {}), { src: url })));
}
